export default __webpack_public_path__ + "static/media/Eternal Faith Gauntlets.dbea401e.jpg";